<template>
    <div>
      <!-- Start Breadcrump Area  -->
      <div
        class="rn-page-title-area pt--120 pb--190 banner-service-details-notin"
        data-black-overlay="5"
      >
        <v-container>
          <v-row>
            <v-col cols="12">
              <div class="rn-page-title text-center pt--100 ">
                <h1 class="headingtitle">Accesibilidad</h1>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <!-- End Breadcrump Area  -->
  
      <div class="rn-service-details rn-section-gap bg_color--1 content-service-details-notin">
        <v-container>
          <v-row>
            <v-col lg="12">
              <div class="inner">
                <!-- Start Single Content  -->
                <v-row
                  class="pb--80 align-items-center text-justify"
                >
                  <v-col lg="12" md="12" cols="12">
                    <div class="contentlegal details mt_md--30 mt_sm--30">
                        <h2>Declaración de Accesibilidad</h2>
                        <p>
                            UNIVERSAL DATA S.L. se ha comprometido a hacer accesible su sitio web de conformidad con el <a title="Real Decreto 1112/2018, de 7 de septiembre, sobre accesibilidad de los sitios web. (Abre en nueva ventana)" href="http://www.boe.es/diario_boe/txt.php?id=BOE-A-2018-12699" style="font-family: inherit;" target="_blank">Real Decreto 1112/2018, de 7 de septiembre, sobre accesibilidad de los sitios web.</a>
                            </p>
                            <p>
                              La presente declaración de accesibilidad se aplica al sitio web <b>{{ NOTARIA.Ruta }}</b>
                            </p>
                        <h3>Situación de cumplimiento</h3>
                        <p>
                            Este sitio web es parcialmente conforme con el RD 1112/2018 debido a las excepciones y a la falta de conformidad de los aspectos que se indican a continuación.
                        </p>
                        <p>&nbsp;</p>
                        <h3>Contenido no accesible</h3>
                        <p>El contenido que se recoge a continuación no es accesible por lo siguiente:</p>
                        <ol style="list-style-type:lower-alpha">
                            <li><b>Falta de conformidad con el RD 1112/2018</b>
                            <ul>
                                <li>
                                    Existen carencias de accesibilidad en contenido de terceros, Google Maps.
                                </li>
                                <li>
                                    Hay enlaces en los que no se identifica correctamente su función (tienen una descripción inadecuada, un texto demasiado genérico, un title inadecuado...) 
                                    [requisito número 9.2.4.4 Propósito de los enlaces, de UNE-EN 301549:2022].
                                </li>
                                <li>
                                    Podrían existir fallos puntuales de edición en alguna página web.
                                </li>
                            </ul>
                        </li>
                        <li><b>Carga desproporcionada</b>
                        <ul><li>No aplica.</li></ul></li>
                        <li><b>El contenido no entra dentro del ámbito de la legislación aplicable</b>
                        <ul><li>No aplica.</li></ul></li>
                        </ol>
                        <p></p>
                        <h3>Preparación de la presente declaración de accesibilidad</h3>

                        <p>La presente declaración fue preparada el 14 de Febrero de 2023.</p>

                        <p>El método empleado para preparar la declaración ha sido una autoevaluación llevada a cabo por el propio organismo.</p>
                        <p></p>
                            <h3 class="md-title">Observaciones y datos de contacto</h3>


                            <div>
                            <p>Puede realizar <span class="negrita">comunicaciones </span>sobre requisitos de accesibilidad (artículo 10.2.a) del RD 1112/2018) como por ejemplo:</p>
                            </div>

                            <ul>
                                <li>informar sobre cualquier posible <span class="negrita">incumplimiento</span> por parte de este&nbsp;sitio web</li>
                                <li>transmitir otras <span class="negrita">dificultades de acceso </span>al contenido</li>
                                <li>formular cualquier otra <span class="negrita">consulta o sugerencia de mejora </span>relativa a la accesibilidad del sitio web</li>
                            </ul>

                            <p>Contactar con la <b>Unidad de accesibilidad</b>, a través del siguiente email: <a href="mailto:web@unidata.es" title="enviar email a web@unidata.es">info@unidata.es</a>  o llamando al teléfono  968882737.</p>
                            

                            <p>Puede presentar:</p>

                            <ul>
                                <li>una <span class="negrita">Queja </span>relativa al cumplimiento de los requisitos del RD 1112/2018 o</li>
                                <li>una <span class="negrita">Solicitud de Información accesible </span>relativa a:
                                <ul>
                                    <li><span class="negrita">contenidos </span>que están <span class="negrita">excluidos</span> del <span class="negrita">ámbito de aplicación </span>del RD 1112/2018 según lo establecido por el artículo 3, apartado 4</li>
                                    <li><span class="negrita">contenidos </span>que están <span class="negrita">exentos </span>del <span class="negrita">cumplimiento </span>de los requisitos de accesibilidad por imponer una <span class="negrita">carga desproporcionada</span>.</li>
                                </ul>
                                </li>
                            </ul>

                            <p>En la Solicitud de información accesible, se debe concretar, con toda claridad, los hechos, razones y petición que permitan constatar que se trata de una solicitud razonable y legítima.</p>
                            <p></p>
                            <h3 class="md-title">Procedimiento de aplicación</h3>

                            <p>A través de este procedimiento podrá iniciar una reclamación para conocer y oponerse a los motivos de la desestimación de una solicitud de información accesible o queja, instar la adopción de las medidas oportunas en el caso de no estar de acuerdo con la decisión adoptada, o exponer las razones por las que se considera que la respuesta no cumple con los requisitos exigidos.</p>
                    </div>
                  </v-col>
                </v-row>
                <!-- End Single Content  -->
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </div>
  </template>
  
<script setup lang="ts">
import { useStore } from '../store/index'
const store = useStore();
const { NOTARIA } = storeToRefs(store)
</script>
  